/*
 * Countdown timer used by the "Countdown" block and announcement bar messages.
 * The end time arrives as a Unix timestamp computed in the store's time zone, so every visitor
 * counts down to the same moment.
 */
if (!customElements.get('countdown-timer')) {
  class CountdownTimer extends HTMLElement {
    connectedCallback() {
      this.end = parseInt(this.dataset.end, 10) * 1000;
      this.start = this.dataset.start ? parseInt(this.dataset.start, 10) * 1000 : 0;
      this.showDays = this.dataset.showDays !== 'false';
      this.values = {};
      this.querySelectorAll('[data-unit]').forEach((el) => (this.values[el.dataset.unit] = el));
      this.tick();
      this.interval = setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      clearInterval(this.interval);
    }

    get designMode() {
      return Boolean(window.Shopify && window.Shopify.designMode);
    }

    setState(state) {
      this.dataset.state = state;
      const hide = state === 'pending' || (state === 'ended' && this.dataset.expired !== 'text');
      this.hidden = hide && !this.designMode;
      this.classList.toggle('countdown--editor-hidden', hide && this.designMode);
    }

    pad(value) {
      return value < 10 ? `0${value}` : String(value);
    }

    tick() {
      const now = Date.now();

      if (this.start && now < this.start) {
        this.setState('pending');
        return;
      }

      let remaining = Math.max(0, Math.floor((this.end - now) / 1000));

      if (remaining === 0) {
        clearInterval(this.interval);
        this.setState('ended');
        Object.values(this.values).forEach((el) => (el.textContent = '00'));
        return;
      }

      this.setState('running');

      const days = Math.floor(remaining / 86400);
      const hours = this.showDays ? Math.floor((remaining % 86400) / 3600) : Math.floor(remaining / 3600);
      const minutes = Math.floor((remaining % 3600) / 60);
      const seconds = remaining % 60;

      if (this.values.days) this.values.days.textContent = this.pad(days);
      if (this.values.hours) this.values.hours.textContent = this.pad(hours);
      if (this.values.minutes) this.values.minutes.textContent = this.pad(minutes);
      if (this.values.seconds) this.values.seconds.textContent = this.pad(seconds);
    }
  }

  customElements.define('countdown-timer', CountdownTimer);
}
